import { SET_LOGGED_USER_PROFILE } from '../actions/userTypes';

export const userInitialState = {
  userId: null,
  email: null,
  name: null,
  permissions: [],
  profileId: null,
  partner: null,
  referenceCode: null,
};

export default (state = userInitialState, action) => {
  switch (action.type) {
    case SET_LOGGED_USER_PROFILE: {
      const {
        userId,
        email,
        name,
        permissions,
        profileId,
        partner,
        referenceCode,
      } = action;
      return {
        ...state,
        userId,
        email,
        name,
        permissions,
        profileId,
        partner,
        referenceCode,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js